import type { Id } from '../convex_generated/dataModel'
import type { TableNames } from '../../../../convex/_generated/dataModel'

/**
 * Mark a plain string as the ID of a document in `Table`.
 *
 * IDs reach the UI as plain strings — from the URL, from DOM callbacks, from
 * locally-typed view models — while Convex function arguments are typed per
 * table. This is the one place that boundary is crossed: it names the table the
 * string is claimed to belong to (the server still validates the ID itself).
 */
export function asId<Table extends TableNames>(id: string): Id<Table>
export function asId<Table extends TableNames>(id: string | null | undefined): Id<Table> | undefined
export function asId<Table extends TableNames>(id: string | null | undefined): Id<Table> | undefined {
  return id ? (id as Id<Table>) : undefined
}
